const API_URL = process.env.REACT_APP_API_URL;

// Shared by lmsApi.js and capstoneApi.js -- every authenticated LMS/capstone
// call attaches the Clerk session token and surfaces the backend's actual
// error message (routes/*.js all respond with { error: '...' } on failure)
// instead of a generic one.
export async function authedFetch(getToken, path, options = {}) {
  const token = await getToken();
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${res.status})`);
  }
  return res.json();
}
